var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proj-bid-new-nav-step"},[_c('EbHeader',[_c('template',{slot:"middle"},[_c('EbNavStep',{attrs:{"navArr":_vm.navArr},on:{"beforeRouteChange":_vm.beforeRouteChange}})],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }